var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60822",
    "data-name": "Group 60822",
    transform: "translate(-12702 -12933)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_472",
    "data-name": "Ellipse 472",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(12702 12933)",
    fill: "#8b69fe",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(12710 12941)",
    fill: "#8b69fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(12727.967 12958.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(0.524 0.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M48.779,28.159H43.842a1.176,1.176,0,1,1,0-2.351h4.937a18.079,18.079,0,0,0,3.526-.471,11.363,11.363,0,0,0,1.645-.705,1.674,1.674,0,0,0,.706-1.41,3.338,3.338,0,0,0-.471-1.411c-1.176-1.41-3.292-2.35-6.113-3.291-.235,0-.235-.235-.471-.235a3.659,3.659,0,0,1-1.41-1.881,2.468,2.468,0,0,1,1.176-2.116c1.645-2.351,2.586-4.466,2.351-6.348A4.365,4.365,0,0,0,48.074,5.12a4.583,4.583,0,0,0-5.408,0,4.367,4.367,0,0,0-1.645,2.821c-.235,1.881.706,4,2.351,6.348A1.176,1.176,0,0,1,41.491,15.7C39.14,12.878,38.2,10.057,38.67,7.471a6.241,6.241,0,0,1,2.586-4.232,6.706,6.706,0,0,1,8.229,0A6.8,6.8,0,0,1,52.07,7.471c.235,2.586-.705,5.408-2.821,8.229-.235.235-.235.47-.471.47a.23.23,0,0,1,.235.235,14.577,14.577,0,0,1,6.818,4,4.47,4.47,0,0,1,1.176,3.057,4.113,4.113,0,0,1-1.646,3.291,7.334,7.334,0,0,1-2.351,1.176C51.6,27.924,50.19,28.159,48.779,28.159Z",
    transform: "translate(-9.988 -1.594)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M14.689,28.09H9.752a11.4,11.4,0,0,1-4.231-.705,7.358,7.358,0,0,1-2.351-1.176,4.49,4.49,0,0,1-1.645-3.292A4.953,4.953,0,0,1,2.7,19.861,16.68,16.68,0,0,1,9.752,16.1a.23.23,0,0,0,.235-.235.818.818,0,0,1-.235-.471C7.4,12.575,6.227,9.518,6.7,7.167A6.235,6.235,0,0,1,9.283,2.935a6.706,6.706,0,0,1,8.229,0A6.8,6.8,0,0,1,20.1,7.167c.235,2.586-.705,5.408-2.821,8.229a1.447,1.447,0,0,1-1.645.235c-.471-.471-.706-1.176-.235-1.646,1.881-2.35,2.586-4.7,2.35-6.347A3.587,3.587,0,0,0,16.1,4.816a4.589,4.589,0,0,0-5.408,0A3.563,3.563,0,0,0,9.048,7.4c-.235,1.881.705,4,2.351,6.347.471.706,1.176,1.411.94,2.116,0,.941-.705,1.411-1.411,1.881a.818.818,0,0,1-.471.235,19.381,19.381,0,0,0-5.877,3.527,3.341,3.341,0,0,0-.471,1.41,1.423,1.423,0,0,0,.705,1.411,11.5,11.5,0,0,0,1.646.705,7.5,7.5,0,0,0,3.291.705H14.69a1.176,1.176,0,1,1,0,2.351Z",
    transform: "translate(-1.524 -1.524)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M32.409,52.183H22.77a14.234,14.234,0,0,1-5.643-.94A8.149,8.149,0,0,1,14.306,49.6a4.356,4.356,0,0,1-2.116-4A5.763,5.763,0,0,1,13.6,41.839c1.881-2.116,4.937-3.762,9.169-5.172l.705-.705-.705-.706c-3.056-4-4.466-7.523-4-10.814a8.8,8.8,0,0,1,3.291-5.408,9.611,9.611,0,0,1,10.58,0,7.862,7.862,0,0,1,3.291,5.408c.471,3.292-.94,7.053-3.761,10.815-.705.705-.705.94-.705.94a3.367,3.367,0,0,1,.705.471c4.232,1.41,7.288,3.056,9.169,5.172A5.338,5.338,0,0,1,42.753,45.6a5.506,5.506,0,0,1-1.881,4.232,8.134,8.134,0,0,1-2.821,1.645,23.166,23.166,0,0,1-5.642.705ZM27.472,19.5a7.927,7.927,0,0,0-4,1.176,5.487,5.487,0,0,0-2.351,4c-.235,2.586.941,5.642,3.292,8.934.705.705,1.411,1.411,1.176,2.586,0,.941-.941,1.646-1.645,2.351a.821.821,0,0,1-.471.235,19.067,19.067,0,0,0-8.463,4.7,5.614,5.614,0,0,0-.471,2.116,2.893,2.893,0,0,0,1.176,2.35,5.5,5.5,0,0,0,2.351,1.176,15.142,15.142,0,0,0,4.7.706h9.639a15.145,15.145,0,0,0,4.7-.706,7.327,7.327,0,0,0,2.351-1.176,2.893,2.893,0,0,0,1.176-2.35,2.553,2.553,0,0,0-.941-2.116c-1.645-1.881-4.466-3.292-8.462-4.7-.236,0-.236-.235-.471-.235-.706-.705-1.646-1.411-1.646-2.351a4.086,4.086,0,0,1,1.411-2.586c2.351-3.056,3.526-6.348,3.292-8.934a5.956,5.956,0,0,0-2.351-4,7.92,7.92,0,0,0-4-1.176Z",
    transform: "translate(-3.962 -5.164)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ec430f644b6cbcb0b4ef8c34732ec401.svg";
export { ForwardRef as ReactComponent };